import React from 'react';
import { useTranslation } from 'react-i18next';
import AppLayout from '../../../components/layout/AppLayout/AppLayout.jsx';
import MovementTable from '../components/tables/MovementTable.jsx';
import { useMovements } from '../hooks/useMovements.js';

const MovementsPage = React.memo(({ onLogout }) => {
    const { t } = useTranslation(['inventory', 'common']);
    const movementsHook = useMovements({
        limitOptions: [20, 50, 100, 200] // Movements-specific pagination options
    });


    // Show loading state only for initial load
    if (movementsHook.loading && (!movementsHook.movements || movementsHook.movements.length === 0)) {
        return (
            <AppLayout 
                title={t('inventory:movements')}
                error={movementsHook.error}
                setError={movementsHook.setError}
                onLogout={onLogout}
            >
                <div className="inventory-container">
                    <div className="loading-state">
                        <div className="spinner"></div>
                        <p>{t('common:messages.loading')}</p>
                    </div>
                </div>
            </AppLayout>
        );
    }

    return (
        <AppLayout 
            title={t('inventory:movements')}
            error={movementsHook.error}
            setError={movementsHook.setError}
            onLogout={onLogout}
        >
            {/* Info card explaining movements */}
            <div className="info-card">
                <h4>📋 {t('inventory:movementHistory')}</h4>
                <p>{t('inventory:movementHistoryDescription')}</p>
            </div>

            {/* Optimized MovementTable handles all table logic */}
            <MovementTable hookData={movementsHook} />
        </AppLayout>
    );
});

export default MovementsPage;